import { Dialog, Slide } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { message, Button, Tooltip } from "antd";
import React from "react";
import IClose from "../assets/icon/close.svg";
import IWarning from "../assets/icon/icWarning.png";
import Ilink from "../assets/icon/icLink2.png";
import { getParamUrlByKey } from "../../../extra/utils";
import Copy from "../assets/icon/icDowload.png";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MdShowlink({ open, dispatch, state }) {
  const { dataStep1, dataStep2, openMdlink } = state;
  const classes = styles();
  const platform = getParamUrlByKey("platform");
  const dataTran = JSON.parse(localStorage.getItem("dataTran"));

  return (
    <Dialog
      open={openMdlink}
      TransitionComponent={Transition}
      className="dialogCenter"
    >
      <div className={classes.container}>
        <div style={{ color: "#3A3A3A" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 18,
              alignItems: "flex-start",
            }}
          >
            <div style={{ textAlign: "center", width: "100%", color: "red" }}>
              <img
                src={IWarning}
                style={{ width: 60 }}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 10,
            textAlign: 'justify',
            fontSize: 16,
            lineHeight: 1.5,
          }}
        >
          Vui lòng vào link để cung cấp hình ảnh xe và hoàn tất thủ tục hợp đồng
          theo hướng dẫn
        </div>
      </div>
      {(dataStep2?.completeInfo?.captureLink || []).map((data, i) => (
        <div key={i} className={classes.link}>
          <div
            onClick={() => {
              if (platform === "app" || dataTran?.platform === "app") {
                window.ReactNativeWebView.postMessage(
                  `/gotoBrownser?link=${data}`
                );
                return;
              }
              window.open(data, "_blank");
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img src={Ilink} style={{ width: 20, marginRight: 10 }} />
            <span>
              Link chụp ảnh
            </span>
          </div>
          <CopyToClipboard
            onCopy={() => message.success("Sao chép link thành công")}
            text={data}
          >
            <img src={Copy} style={{ width: 20 }} />
          </CopyToClipboard>
        </div>
      ))}
      <div style={{ textAlign: "center", marginBottom: 15, display: 'flex', gap: 10, padding: "16px 16px 0px 16px", }}>
        <Button
          style={{ color: '#343A40' }}
          onClick={() => {
            dispatch("closeModalLink");
          }}
          className={classes.buttonCancel}
        >
          Thoát
        </Button>
        <Button
          style={{
            background: `linear-gradient(180deg, #00B3FF -20.16%, #006FFF 64.98%, #003478 121.51%), radial-gradient(65.39% 66.51% at 31.97% 19.67%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%)`,
            color: '#fff',
          }}
          onClick={() => {
            if (platform === "app" || dataTran?.platform === "app") {
              window.ReactNativeWebView.postMessage(
                `/gotoBrownser?link=${dataStep2?.completeInfo?.captureLink[0]}`
              );
              return;
            }
            window.open(dataStep2?.completeInfo?.captureLink[0], "_blank");
          }}
          className={classes.button}
        >
          Truy cập link
        </Button>
      </div>
    </Dialog>
  );
}

const styles = makeStyles(() => ({
  container: { padding: "16px 16px 0px 16px", fontSize: 13 },
  title: { fontSize: 22, marginTop: 10, color: "#383D3B", fontWeight: 600 },
  content: {},
  button: {
    height: 43,
    width: '50%',
    color: "#FFF",
    background: "#009b4b",
    borderRadius: 8,
    border: "1px solid #009b4b",
    fontSize: 16,
    fontWeight: 500
  },
  buttonCancel: {
    height: 43,
    width: '50%',
    color: "#343A40",
    background: "#fff",
    borderRadius: 8,
    border: "1px solid #D2D2D2",
    fontSize: 16,
    fontWeight: 500
  },
  btnCopy: {
    color: "#0044CC",
    fontWeight: 400,
    fontSize: 10,
    border: "1px solid #25806D",
    borderRadius: 4,
    padding: "5px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  link: {
    // width: "100%",
    // wordWrap: "break-word",
    color: "#343A40",
    // textDecoration: "underline",
    borderRadius: 200,
    cursor: "pointer",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 15px",
    border: "1px solid #D2D2D2",
    background: "#fff",
    margin: "16px 16px",
    // borderRadius: 4,
  },
}));
